export default __webpack_public_path__ + "static/media/screen3.107618f8.png";